import React from 'react'
import SecurityManager from 'modules/security/SecurityManager'
import clsx from 'clsx'
import { Link } from 'reacticoon/routing'
import classNames from 'classnames'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import MenuIcon from '@material-ui/icons/Menu'
import TypographyCustom from 'components/TypographyCustom'
import IconButton from '@material-ui/core/IconButton'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import SettingsIcon from '@material-ui/icons/Settings'
import ButtonLink from 'components/ButtonLink'
import LogoIcon from 'components/Logo'
import PermissionView from 'components/PermissionView'
import WebsocketLoading from 'components/WebsocketLoading'
import Search from './Search'
import NotificationsMenu from "./NotificationsMenu"
import Badge from '@material-ui/core/Badge'
import PeopleIcon from '@material-ui/icons/People'
import useCommand from 'components/useCommand'
import { usePlayerCountContext } from '../../contexts/PlayerCountContext'
import Button from '@material-ui/core/Button'

function PlayerCount({ route }) {
  const { playerCount: contextPlayerCount } = usePlayerCountContext()
  const isOnRconPage = route?.name === 'RCON'
  
  const { data: playerCountData, isPending } = useCommand({
    command: 'RCON_GET_PLAYER_COUNT',
    displayError: false,
    manualRun: isOnRconPage, // Auto-run seulement si PAS sur /rcon
  })

  // Si on est sur /rcon, utiliser le contexte (temps réel), sinon utiliser l'API
  const count = isOnRconPage && contextPlayerCount !== null 
    ? contextPlayerCount 
    : (playerCountData ?? 0)

  // Afficher "..." pendant le chargement initial (seulement hors page /rcon)
  if (!isOnRconPage && isPending && count === 0) {
    return (
      <Link to="RCON">
        <IconButton>
          <Badge badgeContent="..." color="default" max={10000}>
            <PeopleIcon />
          </Badge>
        </IconButton>
      </Link>
    )
  }

  return (
    <Link to="RCON">
      <IconButton>
        <Badge badgeContent={count} color="default" max={10000}>
          <PeopleIcon />
        </Badge>
      </IconButton>
    </Link>
  )
}

const styles = (theme) => ({
  title: {
    // flex: 1,
    display: "flex",
    marginLeft: theme.spacing(1),
    alignItems: "center",
    color: theme.isDark ? 'inherit' : theme.palette.text.primary,
    [theme.breakpoints.down('sm')]: {
      display: 'none',
      marginLeft: 0
    },
  },
  menuButton: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(4),
    // 32px de marge à droite du bouton menu, c'est de la largeur perdue quand l'écran est
    // déjà à l'étroit — et c'est justement là que la barre de recherche manque de place.
    [theme.breakpoints.down('sm')]: {
      marginLeft: theme.spacing(0.5),
      marginRight: theme.spacing(0.5),
    },
  },
  logo: {
    marginLeft: theme.spacing(2),
  },
  menuButtonHidden: {
    display: 'none',
  },
  btn: {
    color: theme.isDark ? 'white' : theme.palette.text.primary,
    ...theme.style.focusPrimary,
  },
  loggedContainer: {
    display: 'flex',
    alignItems: "center",
    flex: 1,
    // Sans cela, la barre d'en-tête refuse de descendre sous la largeur de son contenu et
    // la recherche vient chevaucher le bloc de droite au lieu de se réduire.
    minWidth: 0,
  },
  searchContainer: {
    marginLeft: 'auto',
    // La recherche est le seul élément qui peut céder de la place : le compteur de joueurs
    // et le bouton de compte, eux, doivent rester entiers (flexShrink: 0 ci-dessous).
    minWidth: 0,
    flexShrink: 1,
    // flex: 1,
    // maxWidth: 480,
    // margin: 'auto',
  },
  right: {
    display: 'flex',
    marginLeft: 'auto',
    flexShrink: 0,
  },
})

//
//
//

const Logged = ({ me, isMobile, route, classes }) => {
  const [anchorEl, setAnchorEl] = React.useState(null)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  return (
    <div className={classes.loggedContainer}>
      <PermissionView permission="api.general.canPerformQuery">
        <div className={classes.searchContainer}>
          <Search classes={{ search: classes.search }} route={route} />
        </div>
      </PermissionView>
      <div className={clsx(classes.right, 'u-flexCenter u-sizeFullHeight')}>

        {SecurityManager.hasPermission("api.playerList") && (
          <PlayerCount route={route} />
        )}

        <Button
          className={classes.btn}
          variant="text"
          onClick={handleClick}
          endIcon={<AccountCircle />}
        >
          {!isMobile && (
            <React.Fragment>
              {me.gamePlayer && (
                <span>
                  {me.gamePlayer.fullName}
                  &nbsp;-&nbsp;
                </span>
              )}
              {me.username}
            </React.Fragment>
          )}
        </Button>

        <Menu
          anchorEl={anchorEl}
          open={Boolean(anchorEl)}
          onClose={handleClose}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
        >
          <MenuItem
            onClick={() => {
              handleClose()
              window.location.href = '/user-settings'
            }}
          >
            <SettingsIcon style={{ marginRight: 8, fontSize: 20 }} />
            Options
          </MenuItem>
          <MenuItem
            onClick={() => {
              handleClose()
              window.location.href = '/logout'
            }}
            style={{ color: '#ef4444' }}
          >
            <ExitToAppIcon style={{ marginRight: 8, fontSize: 20 }} />
            Se déconnecter
          </MenuItem>
        </Menu>
      </div>
    </div>
  )
}

//
//
//

const useWebsocketLoadingClasses = makeStyles(theme => ({
  root: {
    marginLeft: theme.spacing(1),
  },
}))

/**
 *
 */
const Header = ({ isLoggedIn, isMobile, title, classes, sidebarIsOpen, handleDrawerOpen, me, route }) => {
  const websocketLoadingClasses = useWebsocketLoadingClasses()
  return (
    <React.Fragment>
      {(isMobile || !sidebarIsOpen) && (
        <React.Fragment>
          <IconButton
            color="inherit"
            aria-label="Open drawer"
            onClick={handleDrawerOpen}
            className={classNames(classes.menuButton, !isMobile && sidebarIsOpen && classes.menuButtonHidden)}
          >
            <MenuIcon />
          </IconButton>

          {!isMobile && (
            <Link to="DASHBOARD">
              <LogoIcon width={'auto'} height={42} fill="white" className={classes.logo} />
            </Link>
          )}
        </React.Fragment>
      )}

      <TypographyCustom type="184" className={classes.title} skipColor>
        {title}

        {isLoggedIn && <WebsocketLoading classes={websocketLoadingClasses} />}
      </TypographyCustom>

      {isLoggedIn ? <Logged me={me} classes={classes} isMobile={isMobile} route={route} /> : null}
    </React.Fragment>
  )
}

export default withStyles(styles)(Header)
